module.exports = __webpack_public_path__ + "static/media/sailboat_disabled_ic.11d15c5f.svg";